import * as React from "react";
import { SVGProps, memo } from "react";

const BxBxChevronDown = (props: SVGProps<SVGSVGElement> & { slot?: string }) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16.293 9.293L12 13.586L7.707 9.293L6.293 10.707L12 16.414L17.707 10.707L16.293 9.293Z" fill="currentColor" /></svg>;

const Memo = memo(BxBxChevronDown);
export default Memo;